/**
 * Regular expressions patterns
 * @namespace RE
 */
export const RE = {
    CommaSplit: /,\s*/,
    OneOrMoreWhitespace: /\s+/g,
    WordChars: /\w/g, // [a-zA-Z0-9_]
    notDigit: /[^0-9.]/g,
    Quotes: /^".*"$/,
    StartQuote: /^"/,
    EndQuote: /"$/,
    Spaces: /\s/,
    COLOR: {
        rgbaValues:
            /rgba?\((\d{1,3})(?:,\s*)(\d{1,3})(?:,\s*)(\d{1,3})(?:,\s*)?((?:0|1)?(?:\.\d+)?)?\)/,
        rgbaValidValues:
            /rgba?\((25[0-5]|2[0-4]\d|1?\d{1,2})(?:,\s*)(25[0-5]|2[0-4]\d|1?\d{1,2})(?:,\s*)(25[0-5]|2[0-4]\d|1?\d{1,2})(?:,\s*)?(0?(?:\.\d+)?|1)?\)/
    },
    RFC5322: {
        email: /^(?=.{1,254}$)[^\.][\w\._%+-]+@(?!-)[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/
    },
    MARKUP: {
        editorContent: {
            empty: /<p\s*>(?:\s|\n|<br\/?>|&nbsp;)*<\/p\s*>(\s|\n)*/gm
        }
    },
    INTEGRATION: {
        internal: /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}-internalintegration(\d+)$/
    },
    PLAYBOOK: {
        placeholder: {
            flow: /^FLOW::\w+/,
            playbook: /^PLAYBOOK::\w+/,
            playbookPayload: /^PLAYBOOKPAYLOAD::\w+/,
            flowOrPlaybook: /^(?:FLOW|PLAYBOOK)::\w+/,
            flowOrPlaybookPayload: /^(?:FLOW|PLAYBOOKPAYLOAD)::\w+/,
            playbookOrPlaybookPayload: /^(?:PLAYBOOK|PLAYBOOKPAYLOAD)::\w+/,
            flowOrPlaybookOrPlaybookPayload:
                /^(?:FLOW|PLAYBOOK|PLAYBOOKPAYLOAD)::\w+/,
            flowOrPlaybookOrPlaybookPayloadOrIncidentOrTriageOrCef:
                /^(?:FLOW|PLAYBOOK|PLAYBOOKPAYLOAD|INCIDENT|TRIAGE|CEF)::\w+/,
            arrayLoopInTextArea: /<span\b[^>]*\bloop=["']true["']/
        }
    }
};
